import React from "react";

import Single from "../components/ui/Single";

const Productdetail = () => {
  return (
    <div>
      <Single />
    </div>
  );
};

export default Productdetail;
